import type { ValuesType } from '@fifa-bsm/bo-frontend-shared/utils/types';

export const TicketListType = Object.freeze({
    ALL: 'all',
    WAITING_LIST: 'waitingList',
});

export type ITicketListType = ValuesType<typeof TicketListType>;
